import { Component, Vue } from "vue-property-decorator";
import { CreateElement, VNode } from "vue";
import { Prop } from "vue-property-decorator";
import { Module } from "@/store/enums.ts";
import Card from "./Card";
import "@/styles/util.css";

@Component
export default class ComparisonChart extends Vue {
  @Prop({ default: null }) readingTask!: 1 | 2 | 3 | 4 | 5;
  @Prop({}) dialog!: { show: boolean };

  private headerClass = "text-left subtitle-2";
  private bodyClass = "subtitle-1";
  private bodyClassActive = this.bodyClass + " activeCell";
  private headerClassActive = this.headerClass + " activeCell";

  private rawData: any = {
    1: {
      header: ["Text", this.$store.getters.balaSections[1].shortName],
      body: [
        ["Genre", "Narrative"],
        ["Grade level", "2"],
        ["Overall text complexity", "170"],
        ["Cultural specificity", "Medium"],
        ["Number of words", "259"],
        ["Average words per sentence", "8.9"],
        ["Syntactic complexity (higher = complex)", "28"],
        ["Academic vocabulary", "18"]
      ]
    },
    2: {
      header: ["Text", this.$store.getters.balaSections[2].shortName],
      body: [
        ["Genre", "Expository"],
        ["Grade level", "2"],
        ["Overall text complexity", "150"],
        ["Cultural specificity", "Low"],
        ["Number of words", "233"],
        ["Average words per sentence", "9.0"],
        ["Syntactic complexity (higher = complex)", "32"],
        ["Academic vocabulary", "23"]
      ]
    },
    3: {
      header: ["Text", this.$store.getters.balaSections[3].shortName],
      body: [
        ["Genre", "Expository"],
        ["Grade level", "4"],
        ["Overall text complexity", "440"],
        ["Cultural specificity", "Low"],
        ["Number of words", "452"],
        ["Average words per sentence", "11.3"],
        ["Syntactic complexity (higher = complex)", "41"],
        ["Academic vocabulary", "48"]
      ]
    },
    4: {
      header: ["Text", this.$store.getters.balaSections[4].shortName],
      body: [
        ["Genre", "Narrative"],
        ["Grade level", "5"],
        ["Overall text complexity", "530"],
        ["Cultural specificity", "High"],
        ["Number of words", "432"],
        ["Average words per sentence", "9.0"],
        ["Syntactic complexity (higher = complex)", "30"],
        ["Academic vocabulary", "38"]
      ]
    },
    5: {
      header: ["Text", this.$store.getters.balaSections[5].shortName],
      body: [
        ["Genre", "Narrative"],
        ["Grade level", "6"],
        ["Overall text complexity", "640"],
        ["Cultural specificity", "High"],
        ["Number of words", "305"],
        ["Average words per sentence", "10.5"],
        ["Syntactic complexity (higher = complex)", "43"],
        ["Academic vocabulary", "46"]
      ]
    }
  };

  private data: any;

  created() {
    this.data = this._getFullComparisonChartData();
  }

  private _getFullComparisonChartData() {
    let header = ["Text"];
    let body = [
      ["Genre"],
      ["Grade level"],
      ["Overall text complexity"],
      ["Cultural specificity"],
      ["Number of words"],
      ["Average words per sentence"],
      ["Syntactic complexity (higher = complex)"],
      ["Academic vocabulary"]
    ];

    [1, 2, 3, 4, 5].forEach((i: number) => {
      header.push(this.rawData[i].header[1]);
      this.rawData[i].body.forEach((subitem: any, z: number) => {
        body[z].push(subitem[1]);
      });
    });

    return { header: header, body: body };
  }

  render(h: CreateElement): VNode {
    return (
      <Card
        title="Reading Task Comparison Chart"
        mod={Module.BALA}
        columns="10"
      >
        <v-simple-table slot="mainContent" dense>
          <thead>
            <tr>
              {this.data.header.map((item: any, i: number) => (
                <th
                  class={
                    i == this.readingTask
                      ? this.headerClassActive
                      : this.headerClass
                  }
                >
                  {item}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {this.data.body.map((item: any) => (
              <tr>
                {item.map((subitem: any, i: number) => (
                  <td
                    class={
                      i == this.readingTask
                        ? this.bodyClassActive
                        : this.bodyClass
                    }
                  >
                    {subitem}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </v-simple-table>
        {/* </div> */}
        <div slot="actions">
          <v-btn
            color="secondary"
            onClick={() => {
              this.dialog.show = false;
            }}
          >
            Close
          </v-btn>
        </div>
      </Card>
    );
  }
}

// note this line is extremely important for tsx files that use jsx render,
// otherwise the compononent will not be rendered properly
const component = ComparisonChart;
